import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconPlus = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='15'
            viewBox='0 0 15 15'
            width='15'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M8.67285 6.32422H15V8.72754H8.67285V15H6.27539V8.72754H0V6.32422H6.27539V0H8.67285V6.32422Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconPlus;
